import CRUDService from 'src/services/CRUDService';
import {ScheduledReport} from './scheduled-report-service';

export interface ScheduledReportSetting extends ScheduledReport {
  id: string;
  active: boolean;
}

export default new CRUDService<ScheduledReportSetting>({
  baseUrl: '/v1/admin/scheduled-report-settings',
});
